import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IProductVisibilityListRequest, IProductVisibilityListResponse } from '../models/models'

export class ProductVisibilityListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/product/visibilityList',
      requesterInfo,
    })
  }

  public async productVisibilityList(
    request: IProductVisibilityListRequest
  ): Promise<IProductVisibilityListResponse> {
    return await this.postAsync<IProductVisibilityListResponse>(request)
  }
}
